(() => {
  if (window.sspOutdoorInitialized) return;
  window.sspOutdoorInitialized = true;
  const all = (selector, root=document) => Array.from(root.querySelectorAll(selector));
  const one = (selector, root=document) => root.querySelector(selector);
  let lastFocus;
  const menuTimers = new WeakMap();
  function clearMenuTimers(menu) {
    const timers = menuTimers.get(menu);
    if (timers) { clearTimeout(timers.open); clearTimeout(timers.close); }
  }
  function closeMenus(except) { all('.ssp-outdoor .desktop-navigation details').forEach(d => { if(d!==except) { clearMenuTimers(d); d.open=false; } }); }
  function closeDialog(d) { if(!d) return; const player=one('[data-video-player]',d); if(player) player.removeAttribute('src'); d.close(); document.documentElement.style.overflow=''; if(lastFocus?.isConnected) lastFocus.focus(); }
  function openDialog(name) { const d=document.getElementById('ssp-'+name); if(!d) return; all('.ssp-dialog[open]').forEach(closeDialog); lastFocus=document.activeElement.closest('.desktop-navigation details')?.querySelector('summary') || document.activeElement; closeMenus(); d.showModal(); document.documentElement.style.overflow='hidden'; if(name==='search') one('input[type=search]',d)?.focus(); }
  function showChoice(key,compact=false) {
    const template=one('[data-choice-template="'+key+'"]');
    if(!template)return;
    const current=compact?one('[data-peek-card]'):null;
    if(compact&&current?.dataset.choiceKey===key)return;
    const copy=template.content.firstElementChild.cloneNode(true);
    if(compact){
      copy.classList.add('compact');copy.dataset.peekCard='';copy.dataset.choiceKey=key;
      one('.choice-detail-copy>.text-link',copy)?.remove();
      current?.replaceWith(copy);
      all('[data-peek]').forEach(n=>n.classList.toggle('selected',n.dataset.peek===key));
      all('[data-peek-button]').forEach(n=>n.setAttribute('aria-pressed',String(n.dataset.peekButton===key)));
    }else{
      const target=one('[data-detail-content]');target.replaceChildren(copy);openDialog('detail');
    }
  }
  function vision(key,focus=false) { all('[data-vision]').forEach(b=>{const active=b.dataset.vision===key;b.setAttribute('aria-selected',String(active));b.dataset.state=active?'active':'inactive';b.tabIndex=active?0:-1;if(active&&focus)b.focus();});all('[data-panel]').forEach(p=>p.hidden=p.dataset.panel!==key); }
  function playVideo(id) { const button=one('[data-video="'+id+'"]'); if(!button) return; const player=one('[data-video-player]');const title=button.querySelector('span')?.firstChild?.textContent?.trim()||button.textContent.trim();player.src='https://www.youtube-nocookie.com/embed/'+encodeURIComponent(id)+'?rel=0&playsinline=1&origin='+encodeURIComponent(location.origin);player.title=title;one('[data-video-title]').textContent=title;one('[data-video-watch]').href='https://www.youtube.com/watch?v='+encodeURIComponent(id);all('[data-video]').forEach(b=>b.setAttribute('aria-pressed',String(b===button))); }
  function filterVideos(category) { all('[data-video-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.videoFilter===category)));all('[data-video]').forEach(b=>b.hidden=category!=='All videos'&&b.dataset.category!==category);const visible=all('[data-video]').filter(b=>!b.hidden);const active=visible.find(b=>b.getAttribute('aria-pressed')==='true')||visible[0];if(active)playVideo(active.dataset.video); }
  document.addEventListener('click',event=>{
    const b=event.target.closest('button,a,summary');if(!b)return;
    if(b.matches('[data-open-video]')){event.preventDefault();openDialog('videos');filterVideos('All videos');playVideo(b.dataset.openVideo);}
    else if(b.matches('[data-close-dialog]'))closeDialog(b.closest('dialog'));
    else if(b.matches('[data-open-dialog]'))openDialog(b.dataset.openDialog);
    else if(b.matches('[data-detail]'))showChoice(b.dataset.detail);
    else if(b.matches('[data-peek-button]'))showChoice(b.dataset.peekButton,true);
    else if(b.matches('[data-vision]'))vision(b.dataset.vision);
    else if(b.matches('[data-vision-jump]')){const destination=one('#find-your-pair');if(destination){event.preventDefault();closeMenus();vision(b.dataset.visionJump);destination.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});}else sessionStorage.setItem('ssp-vision',b.dataset.visionJump);}
    else if(b.matches('[data-video-category]')){openDialog('videos');filterVideos(b.dataset.videoCategory);}
    else if(b.matches('[data-video-filter]'))filterVideos(b.dataset.videoFilter);
    else if(b.matches('[data-video]'))playVideo(b.dataset.video);
    else if(b.tagName==='SUMMARY'&&b.closest('.desktop-navigation')){clearMenuTimers(b.parentElement);closeMenus(b.parentElement);}
  });
  document.addEventListener('pointerover',event=>{const row=event.target.closest('[data-peek]');if(row)showChoice(row.dataset.peek,true);});
  document.addEventListener('focusin',event=>{const row=event.target.closest('[data-peek]');if(row)showChoice(row.dataset.peek,true);});
  document.addEventListener('keydown',event=>{if(event.key==='Escape'){const menu=event.target.closest('.desktop-navigation details[open]');closeMenus();if(menu){event.preventDefault();menu.querySelector('summary')?.focus();}return;}const tab=event.target.closest('[data-vision]');if(!tab||!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;const tabs=all('[data-vision]');let i=tabs.indexOf(tab);i=event.key==='Home'?0:event.key==='End'?tabs.length-1:(i+(event.key==='ArrowRight'?1:-1)+tabs.length)%tabs.length;event.preventDefault();vision(tabs[i].dataset.vision,true);});
  document.addEventListener('pointerdown',event=>{if(!event.target.closest('.desktop-navigation'))closeMenus();});
  function bind(){all('.ssp-dialog').forEach(d=>{if(d.dataset.bound)return;d.dataset.bound='true';d.addEventListener('cancel',event=>{event.preventDefault();closeDialog(d);});d.addEventListener('click',event=>{if(event.target!==d)return;const r=d.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)closeDialog(d);});});all('.desktop-navigation details').forEach((d,index)=>{
    if(d.dataset.bound)return;
    d.dataset.bound='true';
    const timers={};menuTimers.set(d,timers);
    const header=d.closest('.site-header');
    const summary=d.querySelector('summary');
    const panel=d.querySelector('[data-slot="navigation-menu-content"]');
    if(panel){panel.id=panel.id||'ssp-navigation-panel-'+index;summary.setAttribute('aria-controls',panel.id);}
    const sync=()=>summary.setAttribute('aria-expanded',String(d.open));
    sync();d.addEventListener('toggle',sync);
    const scheduleClose=()=>{
      clearTimeout(timers.open);clearTimeout(timers.close);
      timers.close=setTimeout(()=>{
        if(!d.matches(':hover')&&!header?.matches(':hover')&&!d.contains(document.activeElement))d.open=false;
      },450);
    };
    d.addEventListener('pointerenter',event=>{
      if(event.pointerType==='touch'||!matchMedia('(hover:hover)').matches)return;
      clearMenuTimers(d);
      if(!d.open)timers.open=setTimeout(()=>{if(d.matches(':hover')){closeMenus(d);d.open=true;}},150);
    });
    d.addEventListener('pointerleave',event=>{if(event.pointerType!=='touch')scheduleClose();});
    header?.addEventListener('pointerleave',event=>{if(event.pointerType!=='touch'&&d.open)scheduleClose();});
    d.addEventListener('focusout',scheduleClose);
  });}

  bind();document.addEventListener('shopify:section:load',bind);
  const previous=sessionStorage.getItem('ssp-vision');if(previous&&one('#find-your-pair')){vision(previous);sessionStorage.removeItem('ssp-vision');}
})();


// Product customization previously depended on the legacy footer's scripts.
(() => {
  function setupPrescriptionLayout() {
    const panel = document.querySelector('.customize-addonpage-top');
    if (!panel) return;
    const isProduct = document.body.classList.contains('template-product');
    const isCustomization = new URLSearchParams(location.search).get('customization') === 'show';
    const visible = !isProduct || isCustomization;
    panel.hidden = !visible;
    if (!visible) return;
    panel.closest('.shopify-section')?.classList.add('ssp-customization-section');
    document.body.classList.toggle('ssp-customization-view', isProduct && isCustomization);
    const $ = window.jQuery;
    if ($?.fn?.owlCarousel) {
      $(panel).find('.customizedSliderNew, .customizedSlider').not('.owl-loaded').owlCarousel({
        loop: false, margin: 18, nav: true, dots: false, autoplay: false,
        responsive: {0: {items: 2}, 768: {items: 3}, 1200: {items: 4}}
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupPrescriptionLayout, {once: true});
  else setupPrescriptionLayout();
  document.addEventListener('shopify:section:load', setupPrescriptionLayout);
})();

(() => {
  document.querySelectorAll('#MainContent iframe[src]').forEach(frame => {
    let url;
    try { url = new URL(frame.getAttribute('src'), location.href); } catch (_) { return; }
    if (!/^(www\.)?youtube(-nocookie)?\.com$/.test(url.hostname)) return;
    const id = url.pathname.split('/').pop();
    if (!/^[A-Za-z0-9_-]{11}$/.test(id)) return;
    frame.referrerPolicy = 'strict-origin-when-cross-origin';
    frame.setAttribute('allowfullscreen', '');
    if (!frame.title) frame.title = document.body.dataset.youtubeLabel;
    const link = document.createElement('a');
    link.className = 'ssp-youtube-fallback';
    link.href = 'https://www.youtube.com/watch?v=' + id;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.textContent = document.body.dataset.youtubeLabel;
    frame.parentElement.insertAdjacentElement('afterend', link);
  });
})();



